import GifPlayer from './GifPlayer';

export default GifPlayer;
